<script lang="ts">
    import EekSheet from '@tilelist/components/eek-sheet/EekSheet.svelte';
    import RatingSheets from '../rating-sheets/RatingSheets.svelte';
</script>

<RatingSheets />
<EekSheet />
